import axios from "axios";
import api from "@/api";

export interface ShortUrlResolution {
  query_params: string;
  app_id: string;
}

/**
 * Service for resolving short URLs to full query parameters.
 */
export class ShortUrlService {
  /**
   * Resolve short URL by calling bridge server.
   * @param appShortCode - 2-character app code (e.g., "dd")
   * @param shortCode - 8-character base58 code
   * @returns Query parameters and app ID
   * @throws Error if resolution fails
   */
  static async resolveShortUrl(
    appShortCode: string,
    shortCode: string
  ): Promise<ShortUrlResolution> {
    try {
      // api.get() already returns just the data, not the full response
      const data = await api.get<ShortUrlResolution>(
        `/${appShortCode}/${shortCode}`
      );
      
      if (!data) {
        throw new Error("Empty response from server");
      }
      
      return data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 404) {
          throw new Error("Short URL not found or expired");
        }
        if (error.response?.status === 400) {
          throw new Error("Invalid short URL format");
        }
        if (error.response) {
          throw new Error(
            `Server error: ${error.response.status} - ${error.response.statusText}`
          );
        }
      }
      throw new Error("Failed to resolve short URL");
    }
  }
}
